import React from "react";

import TopDiagnosticsDtcComplaints from "../../Diagnostics/TopDtcComplaints/TopDtcComplaints";

const TopDtcComplaints = () => {
  return <TopDiagnosticsDtcComplaints route="prognostics" />;
};

export default TopDtcComplaints;
